// Test utilities for Firebase Authentication Session Expiry
import { getAuth, signOut } from "firebase/auth";
import { app } from "../util/firebase";

/**
 * Test function to simulate authentication expiry
 * Call this from browser console: window.testAuthExpiry()
 */
export const simulateAuthExpiry = async () => {
  try {
    const auth = getAuth(app);
    if (auth.currentUser) {
    //   console.log("Simulating auth expiry by signing out user...");
      await signOut(auth);
    //   console.log("User signed out - AuthNotification should appear now");
    } else {
    //   console.log("No user is currently signed in");
    }
  } catch (error) {
    console.error("Error simulating auth expiry:", error);
  }
};

/**
 * Test function to check current auth state
 */
export const checkAuthState = () => {
  const auth = getAuth(app);
  const user = auth.currentUser;
//   console.log("Current auth state:", {
//     isSignedIn: !!user,
//     userId: user?.uid || null,
//     email: user?.email || null,
//     token: localStorage.getItem('FBIdToken') ? 'Present' : 'Missing'
//   });
};

/**
 * Test function to clear local storage tokens (simulates token corruption)
 */
export const clearTokens = () => {
  localStorage.removeItem('FBIdToken');
  localStorage.removeItem('LichessIdToken');
  // console.log("Local storage tokens cleared");
};

// Make functions available globally for testing
if (typeof window !== 'undefined') {
  window.testAuthExpiry = simulateAuthExpiry;
  window.checkAuthState = checkAuthState;
  window.clearTokens = clearTokens;
} 